const hasCapabilities = (token) =>
  token && ('bgd_capabilities' in token || 'bgd_capabilities_v2' in token);

const snakeToCamel = (str) => {
  const word = str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
  return word.charAt(0).toUpperCase() + word.slice(1);
};

const buildLabelHasCapability = (capability) => `has${snakeToCamel(capability)}`;

const validateCapability = (businessTokenData, capability) => {
  // Bypass temporário da dashoard
  if (capability === 'DASHBOARD') return true;

  if (!hasCapabilities(businessTokenData)) {
    return false;
  }

  if ('bgd_capabilities' in businessTokenData) {
    return businessTokenData.bgd_capabilities.find((item) => item.name === capability);
  }

  if ('bgd_capabilities_v2' in businessTokenData) {
    return capability in businessTokenData.bgd_capabilities_v2;
  }

  return false;
};

export const buildCapabilitiesObject = (businessTokenData, capabilities) => 
  capabilities.reduce((acc, capability) => {
    const booleanLabel = buildLabelHasCapability(capability);
    acc[booleanLabel] = validateCapability(businessTokenData, capability);
    return acc;
  }, {});
